import React, { Children } from 'react';
import { PenToolIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Emily Zhang',
  title: 'Professional Illustrator',
  specialties: ["Children's Books", 'Fantasy', 'Character Design'],
  rating: 4.9,
  reviewCount: 134,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$200-600'
}, {
  id: '2',
  name: 'David Lee',
  title: 'Book Illustrator',
  specialties: ['Editorial', 'Concept Art', 'Storyboards'],
  rating: 4.7,
  reviewCount: 98,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$150-450'
}];
const Illustrators = () => <CreativeDirectoryPage title="Illustrators" subtitle="Connect with talented illustrators to bring your stories to life through beautiful artwork" icon={<PenToolIcon className="h-8 w-8" data-id="element-9307" data-mp="2b7ssou9p9d2w" />} profileBasePath="/creative/illustrators" artists={artists} data-id="element-9306" data-mp="337j6in4dvlzr" />;
export default Illustrators;